define('views/layouts/layout-overlay',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // src
    'src/queue/delay-queue',
    // events
    'services/layout',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // src
    DelayQueue,
    // events
    LayoutState
) {

    /**
     * Provides a panel like overlay which toggles an open class (making it
     * slide) and provides common methods to manage the panel, trigger layout
     * events after its defined transition.
     */
    var VLayoutOverlay = Backbone.View.extend({
        className: 'overlay box',

        initialize: function(opt) {
            opt = opt || {};
            this.queue = new DelayQueue({ delay: 200, context: this });

            var content = this.content = opt.view;

            if (content) this.listenTo(content, {
                'back': this.onBack,
                'panel:stack': this.onStack
            });
        },

        render: function() {
            var content = this.getView();
            if (content) {
                this.$el.empty().append(content.render().el);
            }
            return this;
        },

        is: function(view) {
            return this.getView() === view;
        },

        isOpened: function() {
            return this.$el.hasClass('open');
        },

        getView: function() {
            return this.content;
        },

        close: function() {
            return this.toggle(false);
        },

        _close: function() {
            this._toggle(false);
        },

        /**
         * The drawer takes T seconds to open/close where T is defined in
         * the CSS as a transition. In order to provide queued promises after
         * each step of the transition, we use a custom DelayQueue class.
         */
        toggle: function(val) {
            return this.queue.add(this._toggle, val, {
                    condition: function() { return this.isOpened() !== val; }
                })
                .done(this._afterToggle);
        },

        _toggle: function(val) {
            this.$el.toggleClass('open', val);
        },

        _afterToggle: function() {
            var opened = this.isOpened();
            this.trigger(opened ? 'opened' : 'closed');
            this.trigger('toggled', opened);
        },

        ////////////
        // events //
        ////////////
        onBack: function() {
            this.trigger('back', this);
        },

        onStack: function(view) {
            this.trigger('panel:stack', view);
        },

    });

    return VLayoutOverlay;
});

